import { useQuery } from "react-query";
import { getProjects } from "../../services/scientific/project";
import { PagedRequestType } from "../../types/PagedResults";
import { Key_projects, PROJECTS } from "../../utils/constants";


export const useGetProjectsQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_projects, JSON.stringify(data)],
    () => getProjects(data)
  );
